import React, { useState } from "react";
import SelectField from "../../ReusableComponents/SelectField";
import Form from "../../ReusableComponents/Form";
import { Button } from "../../Components/Helper";
import { selectFieldValidation } from "../../utils/inputValidations";

export const ExcelValidationForm = ({ renamedColumns, onsubmit, MandatoryColumns, validation ,close}) => {
  const [selectedValues, setSelectedValues] = useState({});


  const handleSelectChange = (fieldKey, selectedOption) => {
    setSelectedValues((prev) => ({
      ...prev,
      [fieldKey]: selectedOption?.value || "",
    }));
  };

  const getFilteredOptions = (currentFieldKey) => {
    const usedValues = Object.entries(selectedValues)
      .filter(([key]) => key !== currentFieldKey)
      .map(([, value]) => value);

    return renamedColumns
      .filter((col) => !usedValues.includes(col))
      .map((col) => ({ label: col, value: col }));
  };

  return (
    <Form
      onSubmitForm={(req) => {
        console.log("Final Mapping:", selectedValues);
        if (onsubmit) onsubmit(selectedValues)
      }}
    >
      {(onSubmit, formValue) => (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "30px" }}>
            {Array.from({ length: Math.ceil(MandatoryColumns.length / 2) }).map((_, rowIndex) => {
              const rowFields = MandatoryColumns.slice(rowIndex * 2, rowIndex * 2 + 2);
              return (
                <div key={rowIndex} style={{ display: "flex", gap: "20px" }}>
                  {rowFields.map((field) => {
                    const fieldKey = field;
                    return (
                      <div key={fieldKey} style={{ display: "flex", alignItems: "center", flex: 1 }}>
                        <div style={{ flex: 1 }}>
                          <SelectField
                            name={fieldKey}
                            value={
                              selectedValues[fieldKey]
                                ? { label: selectedValues[fieldKey], value: selectedValues[fieldKey] }
                                : null
                            }
                            label={fieldKey}
                            placeholderText={"Select column to assign"}
                            list={getFilteredOptions(fieldKey)}
                            handleChange={(selected) => handleSelectChange(fieldKey, selected)}
                            styles={{
                              width: "70%",
                              height: "18px",
                              fontSize: "13px",
                            }}
                            validation={validation.find(x => x === fieldKey) ? selectFieldValidation : null}
                            containerStyle={{ width: "100%", minHeight: "40px" }}
                            isSearchable
                          />
                        </div>
                      </div>
                    );
                  })}

                  {/* Filler div for alignment if only one item in row */}
                  {rowFields.length === 1 && <div style={{ flex: 1 }}></div>}
                </div>
              );
            })}


            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
              <div></div>
              <div style={{ display: "flex", justifyContent: "space-between",width:"267px" }}>
              <Button style={{
                    whiteSpace: "nowrap",
                    height: "30px",
                    marginBottom: "10px",
                    marginRight: "5px",
                    width:"100%",
                    borderColor:"#BFC8D9",
                    color:"#606571"
                  }}
                                                  text={"Cancel"}
                                                  type={"button"}
                                                  onClick={()=>{
                                                    close()
                                                  }}
                                                  isBtnNotActive={true}
                                                  className={"btn-large "}
                                              />

                <Button
                  // isDisabled={Object.keys(selectedValues).length === 0}
                  style={{
                    whiteSpace: "nowrap",
                    height: "30px",
                    marginBottom: "10px",
                    marginRight: "5px",
                    width:"100%"
                  }}
                  text={"Next"}
                  onClick={() => { }}
                  className="btn-large"
                />
              </div>
            </div>
          </div>





        </>
      )}
    </Form>
  );
};
